import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { loginUser } from "../api";
import { useNavigate } from "react-router-dom";
import Banner from "../components/Banner";

const Login = () => {
  const [formData, setFormData] = useState({
    usuario: "",
    contrasena: "",
    tipo_usuario: "halcon", // Default value
  });

  const [error, setError] = useState("");
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Attempt to login the user
      const userData = await loginUser(formData);
      if (userData && !userData.error) {
        login(userData);
      } else {
        setError(userData.error);}
      // Extract tipo_usuario from the user data
      const { tipo_usuario } = userData[0];

      // Redirect based on tipo_usuario
            if (tipo_usuario === "halcon") {
        navigate("/halcon", { state: { userData } });
      } else if (tipo_usuario === "lider") {
        navigate("/lider", { state: { userData } });
      } else if (tipo_usuario === "admin") {
        navigate("/admin", { state: { userData } });
      } else {
        // Log and throw error if tipo_usuario is invalid
        console.error("Invalid user type:", tipo_usuario);
        throw new Error("Invalid user type.");
      }
    } catch (err) {
      // Log the error if login or redirection fails
      console.error("Error during login:", err);
    }
  };

  return (
    <div className="container">
      <Banner />
      <h1 className="title">Login</h1>
      <center><a href="/">home</a></center>
      {error && <p style={{ color: "red" }}>{error}</p>}
      <form onSubmit={handleSubmit} className="form">
        <div className="input-group">
          <label className="label">Usuario:</label>
          <input
            type="text"
            name="usuario"
            value={formData.usuario}
            onChange={handleInputChange}
            className="input"
            required
            placeholder="nombre de usuario"
          />
        </div>
        <div className="input-group">
          <label className="label">Contraseña:</label>
          <input
            type="password"
            name="contrasena"
            value={formData.contrasena}
            onChange={handleInputChange}
            className="input"
            required
            placeholder="contraseña"
          />
        </div>
        <div>
          <label className="label">Tipo de Usuario:</label>
          <select
            name="tipo_usuario"
            value={formData.tipo_usuario}
            onChange={handleInputChange}
          >
            <option value="halcon">Halcon</option>
            <option value="lider">Apoyo</option>
            <option value="admin">Coach</option>
          </select>
        </div>
        <p></p>
        <button type="submit" className="button">Login</button>
      </form>
      <center><h3><a href="/recuperar_pwd">Olvide contraseña</a></h3></center>
    </div>
  );
};

export default Login;
